import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Navigation from '../../../components/Navigation/Navigation';
import NavigationButton from '../../../components/Navigation/NavigationButton';
import style from './AcceptData.module.scss';

interface AcceptDataProps {
  isLoading: boolean;
  onSave: () => Promise<boolean>;
}

const AcceptData: FC<AcceptDataProps> = ({ isLoading, onSave }) => {
  const { t } = useTranslation();

  return (
    <div className={style.acceptData}>
      <div className={style.buttonsContainer}>
        <Navigation className={style.fullButtonMobile}>
          <NavigationButton
            buttonAction="next"
            nextDisabled={isLoading}
            preNavigateAction={onSave}
            text={t('button:nextStep')}
          />
        </Navigation>
      </div>
    </div>
  );
};

export default AcceptData;
